import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType, InteractionStatus } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { CONFIG } from 'src/helper/app-config';
import { UserService } from 'src/services/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})


export class AppComponent {
  title = 'angular-cci-builder';
  isIframe = false;
  login_display = false;
  private readonly _destroying$ = new Subject<void>();
  saved_access_token_db ='';
  showAppBar: boolean = false; 


  constructor(private broadcastService: MsalBroadcastService, private authService: MsalService, private userService: UserService,private router: Router) { }

  ngOnInit() {

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.showAppBar = event.url !== `/${CONFIG.PATH.LANDING_PAGE}` && event.url !== `/${CONFIG.PATH.LOGIN}` && event.url !== "/" ?true:false;
        // console.log("showAppBar",this.showAppBar)
        // console.log("showAppBar",event.url)
        // console.log("showAppBar",event.url !== `/${CONFIG.PATH.LANDING_PAGE}`)
        // console.log("showAppBar",event.url !== `/${CONFIG.PATH.LOGIN}`)
      }
    });
    this.isIframe = window !== window.parent && !window.opener;
    this.broadcastService.msalSubject$
    .pipe(
      filter((msg: EventMessage) => msg.eventType === EventType.ACQUIRE_TOKEN_SUCCESS),
    )
    .subscribe({next:(result: EventMessage) => {
      const authResult = result.payload as AuthenticationResult;
      if(result.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || result.eventType === EventType.LOGIN_SUCCESS){
        this.saveToken(result.payload)
        if(authResult&&authResult.account!==null){
            // console.log(authResult)
          this.authService.instance.setActiveAccount(authResult.account);
          // this.router.navigate(['/landing-page'])
          // const activeAccount = this.authService.instance.getActiveAccount();
    // console.log('Active Account:', activeAccount);
        }
      }
    },
    error: (error) => {
        console.log("error :: ", error)
    }
  });

    this.broadcastService.inProgress$
    .pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this._destroying$)
    )
    .subscribe(() => {
      this.login_display = this.authService.instance.getAllAccounts().length > 0;
    })
  }


  saveToken(payload: any){
    if(this.saved_access_token_db !== payload.accessToken){
      let user_info = {username: payload.account.username,
        access_token:payload.accessToken,
        // expiresOn:payload.expiresOn,
        name:payload.account.name
      }
      localStorage.setItem("user_name",payload.account.username.split("@")[0])
      this.userService.saveUserToken(user_info).subscribe({
        next: (res: any) => {
          this.saved_access_token_db = res.data.access_token;

          localStorage.setItem("user_id",res.data.user_id)
          localStorage.setItem("admin_flag",res.data.admin_flag)
        }, error: (error) => {
          console.log("error :: ", error)
        }
      });
    }
    
  }

  login() {
    this.authService.loginRedirect();
  }

  logout(){
    this.authService.logoutRedirect();
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }
}
